'use client';
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { ErrorBoundary } from '@castlery/fortress';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    // Log the error to an error reporting service
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <ErrorBoundary type="page" retryEvent={reset} dyDataCampaign="" />
      </body>
    </html>
  );
}
